module.exports = __webpack_public_path__ + "img/LogoDropship.a5fd4bc2.png";